import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const selectAuth = createFeatureSelector<AuthState>('auth');

export const selectToken = createSelector(selectAuth, s => s.token);
export const selectUser = createSelector(selectAuth, s => s.user);
export const selectSelectedAgency = createSelector(selectAuth, s => s.selectedAgency);
export const selectIsLoggedIn = createSelector(selectAuth, s => !!s.token);
export const selectUserRole = createSelector(selectUser, u => u?.role ?? null);
